
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getVessel: (state) => state.vessel,
  getVessels: (state) => state.vessels,
  getVesselsMap: (state) => state.vesselsMap,
  getVesselNames: (state) => state.vesselNames,

  getVesselsFilterData: (state) => state.vesselsFilterData
}